import { useMediaQuery } from '@mui/material';

import mainTheme from '../assets/styles/themes/mainTheme';

// Breakpoint constant for very small mobile screens (0-374px)
const BREAKPOINT_XXS_MAX = 374;

export type ScreenSizeCategory = 'small' | 'medium' | 'large';

/**
 * Categorizes screen size into small (XXS/XS), medium (SM), or large (MD/LG)
 * Useful for responsive styling decisions that group breakpoints together
 */
export const getScreenSizeCategory = (
	isXxsScreen: boolean,
	isXsScreen: boolean,
	isSmScreen: boolean
): ScreenSizeCategory => {
	if (isXxsScreen || isXsScreen) return 'small';
	if (isSmScreen) return 'medium';
	return 'large';
};

const useScreenSize = () => {
	const isXxsScreen = useMediaQuery(`(max-width:${BREAKPOINT_XXS_MAX}px)`, {
		noSsr: true,
	});
	const isXsScreen = useMediaQuery(mainTheme.breakpoints.only('xs'), {
		noSsr: true,
	});
	const isSmScreen = useMediaQuery(mainTheme.breakpoints.between('sm', 'md'), {
		noSsr: true,
	});
	const isMdScreen = useMediaQuery(mainTheme.breakpoints.between('md', 'lg'), {
		noSsr: true,
	});
	const isLgScreen = useMediaQuery(mainTheme.breakpoints.up('lg'), {
		noSsr: true,
	});

	return {
		isXxsScreen,
		isXsScreen,
		isSmScreen,
		isMdScreen,
		isLgScreen,
	};
};

export default useScreenSize;
